import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DomainVerificationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"domain_verification"}/>
}
